import { createContext } from 'react';
import * as Types from 'pages/Pages/typings';

export default createContext<null | { [key: string]: Types.EntityType }>(null);
